import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { LexdexLogo } from '../components/LexdexLogo';
import './RequestPasswordReset.css';

const API_URL = import.meta.env.VITE_API_URL || 'https://1v6zm22cmf.execute-api.us-west-2.amazonaws.com/prod';

const RequestPasswordReset: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const apiUrl = API_URL?.endsWith('/') ? API_URL : `${API_URL || ''}/`;
      console.log('Requesting password reset for:', email);
      console.log('API URL:', apiUrl);
      await axios.post(`${apiUrl}auth/request-reset`, { email });
      console.log('Password reset request successful');
      setSuccess(true);
      setEmail('');
    } catch (err: any) {
      console.error('Password reset error:', err);
      // Always show success to prevent email enumeration
      setSuccess(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="request-reset-container">
      <div className="request-reset-card">
        <div className="request-reset-logo-container">
          <LexdexLogo className="request-reset-logo" showText={false} />
        </div>

        <h1 className="request-reset-title">Reset Your Password</h1>

        {!success ? (
          <>
            <p className="request-reset-description">
              Enter your email address and we'll send you a link to reset your password.
            </p>

            <form onSubmit={handleSubmit} className="request-reset-form">
              {error && (
                <div className="request-reset-error">
                  {error}
                </div>
              )}

              <div className="request-reset-input-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  disabled={loading}
                />
              </div>

              <button
                type="submit"
                className="request-reset-button"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>

            <div className="request-reset-back">
              <Link to="/login">← Back to Login</Link>
            </div>
          </>
        ) : (
          <div className="request-reset-success">
            <div className="success-icon">✓</div>
            <h2>Check Your Email</h2>
            <p>
              If an account exists with this email, we've sent a password reset link.
              Please check your inbox and spam folder.
            </p>
            <p className="success-note">
              The link will expire in 1 hour.
            </p>
            <Link to="/login" className="request-reset-button">
              Return to Login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestPasswordReset;

